export default __webpack_public_path__ + "8798fcc6fd2d5d3aeccea6ee3fcfec89.svg";